import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { isIos, isAndroid, inWeixin } from 'web-launch-app';
import { Toast } from "antd-mobile";
import './index.css'
import CommonApi from "../../api/common";
import { getParameter } from "../../utils/func";
import 'antd-mobile/dist/antd-mobile.css'

const DownloadExperience = () => {
    let location = useLocation();
    const appId = 'wx754e1b2a81936e91'

    const openApp = () => {
        if (isIos) {
            window.location.replace("https://apps.apple.com/cn/app/id1599638541");
        } else if (isAndroid) {
            if (inWeixin) {
                window.location.replace("https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.doublecircleclock");
            }
        } else {
            window.location.href = "https://www.kairusi.com/html/product.html";
        }
    };

    useEffect(() => {
        const token = getParameter("token", location.search);
        const code = getParameter("code");
        if (code) {
            CommonApi.getWxOpenId({ share_token: token, code }).then(res => {
                openApp()
            }).catch(error => {
                if (error.message) {
                    Toast.info(error.message)
                }
            })
        }
    }, []);

    const toWxpayAuth = () => {
        // let isPad = navigator.userAgent.indexOf('iPad') > -1;
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/dbclock/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    };

    return (
        <div className="download-page">
            <img src={require("../../image/download-bg.png").default} alt="" className="download-bg" />
            <div className="download-header">
                <img src={require("../../image/download-logo.png").default} alt="" className="download-icon" />
                <img src={require("../../image/download-tips.png").default} alt="" className="download-tips" />
                <img src={require("../../image/dowload-mark.png").default} alt="" className="download-mark" />
            </div>
            <div className="download-btn" onClick={toWxpayAuth}>立即体验</div>
        </div>
    )
};

export default DownloadExperience;